module.exports = __webpack_public_path__ + "img/inter25.a3505314.jpg";